<template>
  <div class="pay">
    <van-nav-bar title="请假记录" left-text="返回" left-arrow @click-left="$router.go('-1')" />

    <c-card class="pay-row c-margin-top-normal" v-for="(item, index) in list" :key="index">
      <p class="pay-row-item">
        <label class="pay-row-item__title">学生姓名：</label>
        {{ item.Studentname }}
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">开始日期：</label>
        {{ item.Leavestattime }} 
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">结束日期：</label>
        {{ item.Leaveendtime }}
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">请假时长：</label>
        {{ totalTime(item) }}
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">请假类型：</label>
        <span v-if="item.Leavetype == 1">病假</span>
        <span v-else-if="item.Leavetype == 2">事假</span>
        <span v-else>其他</span>
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">状态：</label>
        <span v-if="item.Status == 0">待审核</span>
        <span v-else-if="item.Status == 1">不同意</span>
        <span v-else-if="item.Status == 2">审核通过</span>
        <span v-else>不同意</span>
      </p>
     
      <p class="pay-row-item">
        <label class="pay-row-item__title">审核时间：</label>
        {{ item.Approvetime || '' }}
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">创建时间：</label>
        {{ item.Createtime }}
      </p>
      
    </c-card>
  </div>
</template>

<script>
import { NavBar, NoticeBar, Toast } from 'vant'
import CCard from '@/components/c-card.vue'
import CTitle from '@/components/c-title'

export default {
  data() {
    return {
      showTimeBegin: false,
      showTimeEnd: false,

      time_begin: '',
      time_end: '',
      pickerBeginTime: new Date(),
      pickerEndTime: new Date(),

      beginRadio: '1',
      endRadio: '1',
      studentInfo:{},
      list: []
    }
  },
  
  created() {
    var sinfo = localStorage.getItem("currentChild");
        this.studentInfo = JSON.parse(sinfo);
        console.log("sinfo",sinfo)
        if(this.studentInfo.Studentid=="" || this.studentInfo.Studentid==null){
          Toast("未选定孩子")
          this.$router.push("/my");
          return;
        }
    this.getList()
  },
  mounted(){
  },
  methods: {
    totalTime(item){
      var s1 =new Date(item.Leavestattime.replace(/-/g,'/'))
      var s2=new Date(item.Leaveendtime.replace(/-/g,'/'))
      
      var total =(s2.getTime()-s1.getTime()) / 1000/3600
      //alert(total)
      var day = Math.floor(total / 24)
      var hours = total % 24 
      var stimes =''
      if (day==0){
        stimes= hours + " 小时" 
      }else {
        if (hours==0){
          stimes = day + " 天"
        }else {
          stimes = day +" 天 "+ hours +" 小时 "
        }
      }
      return stimes
    },
    // 获取请假信息
    getList() {
      this.$http
        .json_post(this.$api.leave.qingjialist, {
          Studentid: eval(this.studentInfo.Studentid),
          Pageindex: 1,
          Pagesize: 120
        })
        .then(data => {
          if (data.code == 0) {
            this.list = data.data
            console.log(data, 111)
          }else {
            Toast(data.msg)
          }
        })
    },
    changeBeginTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour = val.getHours()
      var minute = val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`
      }
      this.time_begin = `${year}-${month}-${day} ${hour}:${minute}`
      this.showTimeBegin = false
    },

    changeEndTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour = val.getHours()
      var minute = val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`
      }
      this.time_end = `${year}-${month}-${day} ${hour}:${minute}`
      this.showTimeEnd = false
    },

    stringToArr(str) {
      var weekArr = ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
      var retArr = new Array()
      var strings = str.split(';')
      for (var i = 0; i < strings.length; i++) {
        var model = {}
        var strs1 = strings[i].split('|')
        var strs2 = strs1[0].split(',')
        var strs3 = strs1[1].split(',')
        model.beiginName = weekArr[parseInt(strs2[0])]
        model.endName = weekArr[parseInt(strs2[1])]
        model.begin = strs3[0]
        model.end = strs3[1]
        retArr[i] = model
      }
      return retArr
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-notice-bar': NoticeBar,
    'c-card': CCard,
    CTitle
  }
}
</script>

<style lang="scss" scoped>
.pay-row-item {
  line-height: 20px;
  .pay-row-item__title {
    display: inline-block;
    width: 80px;
    color: $text-secondary-color;
  }
}
.w300 {
  margin-left: 10px;
  width: 220px;
}
</style>
